import {PPClientSideMessagesHandler} from '@gongxigames/framework/integrations/pariplay';

export class PariplayFusionPostMessagesHandler extends PPClientSideMessagesHandler {
    protected _balance?: number;

    protected setupEvents(): void {
        super.setupEvents();

        this._eventManager.on('General.UI.BALANCE.UPDATED', this.onBalanceUpdated.bind(this), this);
    }

    protected onBalanceUpdated(amount: number): void {
        this._balance ??= amount;

        if (this._balance !== amount) {
            this._balance = amount;

            this.postMessage('balanceUpdate', {amount});
        }
    }
}